export default __webpack_public_path__ + "static/media/ellie_1080.03267451.mp4";